import { IUserBadgeRanking } from "interfaces/badge.interface";
import { USER_BADGES_REPORT } from "./endpoint-urls";
import http from "./http-service";

export const getUserBadgesReport = () => {
  return http.get<IUserBadgeRanking>(`${USER_BADGES_REPORT}`).then((res) => {
    return res.data;
  });
};
